import React, { useState, useEffect,useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import './HYBRID_Token_Class_S.css';

const HYBRID_Token_Class_S = (props) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();
  let selectedData ="";
  
  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };



  

  useEffect(() => {
    document.title = "SRWAE | "+t('Hybrid Token Token Class');  

 const handleReturn = async () => {
    const collectClientInfo = () => {
      return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        screenResolution: `${screen.width}x${screen.height}`,
        colorDepth: screen.colorDepth,
        timezoneOffset: new Date().getTimezoneOffset(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        cookieEnabled: navigator.cookieEnabled,
        javaEnabled: navigator.javaEnabled(),
        online: navigator.onLine,
        referrer: document.referrer,
        locationHref: window.location.href,
        screenOrientation: screen.orientation?.type || 'unknown'
      };
    };

    const clientInfo = collectClientInfo();

    try {
      const response = await fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_TOKEN_CLASS/Select', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: App_Data.Data, clientInfo: clientInfo, stamp: Date.now() })
      });

      if (response.ok) {
        navigate('/HYBRID_Token_Class', { replace: true });
      } else {
        console.error("Select call failed with status:", response.status);
      }
    } catch (err) {
      console.error("Select fetch error:", err);
    }
  };	  
	  
	for (let i = 1; i <= 1; i++) {
	  const sectionId = `#HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_${i}_SECTION`;
	  const headerId = `#HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [1];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
	
	const searchInput = $('input[type="search"]');
 	const Temp_Search = App_Data["Object_Search"];
	if(Temp_Search!=""){
		searchInput.val(Temp_Search);
	}

	if(location.hash=="#Return"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};
		
		const clientInfo = collectClientInfo();

		fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_TOKEN_CLASS/Select', {
		  method: 'POST',
		  headers: { 'Content-Type': 'application/json' },
		  body: JSON.stringify({ data:(App_Data&&App_Data.Data?App_Data.Data:{id:-1}) , clientInfo:clientInfo , stamp: Date.now() })
		}).catch(err => {
		  console.error("Error", err);
		});			
		navigate('/HYBRID_Token_Class',{replace:true});
	}
	if(location.hash=="#New"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Token_Class',{replace:true});
	}
	if(location.hash=="#Search"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Token_Class_S',{replace:true});
	}
	if(location.hash=="#Update"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Token_Class',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Token_Class_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Token_Class_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Token_Class_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Token_Class',{replace:true});
	}
	if(location.hash=="#Export"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Token_Class',{replace:true});
	}
	if(location.hash=="#Import"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Token_Class',{replace:true});
	}
	if(location.hash=="#Help"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Token_Class',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setApp_Data({ ...App_Data});
		navigate('/HYBRID_Token_Class',{replace:true});
	}

     	    window.DataTableScript('#Table9');

  })  

  const [HYBRID_TOKEN_CLASS, setHYBRID_TOKEN_CLASS] = React.useState(null);
  const [HYBRID_TOKEN_CLASS_S, setHYBRID_TOKEN_CLASS_S] = React.useState(null);

  var Ids = [];
  for(var Ele in HYBRID_TOKEN_CLASS_S){
	  for(var Sec in HYBRID_TOKEN_CLASS_S[Ele]){
			if(Sec == "id")
				Ids.push(HYBRID_TOKEN_CLASS_S[Ele]["id"]);
			else if(Sec == "status")
				Ids.push(HYBRID_TOKEN_CLASS_S[Ele]["status"]);
			else if(Array.isArray(HYBRID_TOKEN_CLASS_S[Ele][Sec]))
				  for(var Row in HYBRID_TOKEN_CLASS_S[Ele][Sec])
					for (var Id in Row) 
						Ids.push(Id);
			else
				for (var Id in HYBRID_TOKEN_CLASS_S[Ele][Sec]) 
					Ids.push(Id);
	  }
  }
  
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
    axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_TOKEN_CLASS`).then((response) => {
      setHYBRID_TOKEN_CLASS(response.data);
	  
		var Temp_Detail = [];
		Object.keys(response.data).map((key, index) => {
		  var Temp_Obj={};
		  var Temp_Val = JSON.parse(JSON.stringify(response.data[index]));
		  for(var Sec in Temp_Val){
		     if(Sec == "id")
						Temp_Obj["id"] = Temp_Val[Sec];
			 else if(Array.isArray(Temp_Val[Sec])){
					  for(var Row in Temp_Val[Sec])
						for (var Id in Temp_Val[Sec][Row]){ 
							if(Temp_Obj.hasOwnProperty(Id))
								Temp_Obj[Id] += "|||"+Temp_Val[Sec][Row][Id];
							else
								Temp_Obj[Id]=Temp_Val[Sec][Row][Id];
						}
			}else{
				for (var Id in Temp_Val[Sec]){ 
					Temp_Obj[Id] = Temp_Val[Sec][Id];
				}
			}
		  }
		  Temp_Detail.push(Temp_Obj);
	  })
	  //setALLFIELDS_S(JSON.parse(JSON.stringify(Temp_Detail)));	  

	setHYBRID_TOKEN_CLASS_S(JSON.parse(JSON.stringify(Temp_Detail)));
	  
	  
	  
    });
	//$('#navbarNav1').show();
//$('#navbarNav6').show();

  }, []);

  if (!HYBRID_TOKEN_CLASS_S) return <div>Loading...</div>;

 const handleLastDataHYBRID_TOKEN_CLASS_S = async (data) => {
  };




  const handleAddHYBRID_TOKEN_CLASS_S = async () => {
    try {
      await axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_TOKEN_CLASS_S', JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS_S)));

      const response = await axios.get('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_TOKEN_CLASS_S');
      setHYBRID_TOKEN_CLASS_S(response.data);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
  

    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS_S));
	Temp_Data["1"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_0"]=value;
	//handleAddHYBRID_TOKEN_CLASS_S(Temp_Data,App_Data['HYBRID_TOKEN_CLASS_S']);
	Form_Data_onChange("1","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_0",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS_S(Temp_Data);
    setHYBRID_TOKEN_CLASS_S(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS_S));
	Temp_Data["1"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_1"]=value;
	//handleAddHYBRID_TOKEN_CLASS_S(Temp_Data,App_Data['HYBRID_TOKEN_CLASS_S']);
	Form_Data_onChange("1","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_1",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS_S(Temp_Data);
    setHYBRID_TOKEN_CLASS_S(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS_S));
	Temp_Data["1"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_2"]=value;
	//handleAddHYBRID_TOKEN_CLASS_S(Temp_Data,App_Data['HYBRID_TOKEN_CLASS_S']);
	Form_Data_onChange("1","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_2",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS_S(Temp_Data);
    setHYBRID_TOKEN_CLASS_S(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS_S));
	Temp_Data["1"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_3"]=value;
	//handleAddHYBRID_TOKEN_CLASS_S(Temp_Data,App_Data['HYBRID_TOKEN_CLASS_S']);
	Form_Data_onChange("1","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_3",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS_S(Temp_Data);
    setHYBRID_TOKEN_CLASS_S(Temp_Data);
 }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS));
	Temp_Data["2"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_0"]=value;
	Form_Data_onChange("2","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_0",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS(Temp_Data);
    setHYBRID_TOKEN_CLASS(Temp_Data);
	//handleAddHYBRID_TOKEN_CLASS(Temp_Data,App_Data['HYBRID_TOKEN_CLASS']);
  }; 
  


const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS));
	Temp_Data["2"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_1"]=value;
	Form_Data_onChange("2","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_1",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS(Temp_Data);
    setHYBRID_TOKEN_CLASS(Temp_Data);
	//handleAddHYBRID_TOKEN_CLASS(Temp_Data,App_Data['HYBRID_TOKEN_CLASS']);
  }; 
  


const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS));
	Temp_Data["2"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_2"]=value;
	Form_Data_onChange("2","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_2",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS(Temp_Data);
    setHYBRID_TOKEN_CLASS(Temp_Data);
	//handleAddHYBRID_TOKEN_CLASS(Temp_Data,App_Data['HYBRID_TOKEN_CLASS']);
  }; 
  

    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS_S));
	Temp_Data["3"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_0"]=value;
	//handleAddHYBRID_TOKEN_CLASS_S(Temp_Data,App_Data['HYBRID_TOKEN_CLASS_S']);
	Form_Data_onChange("3","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_0",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS_S(Temp_Data);
    setHYBRID_TOKEN_CLASS_S(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS_S));
	Temp_Data["3"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_1"]=value;
	//handleAddHYBRID_TOKEN_CLASS_S(Temp_Data,App_Data['HYBRID_TOKEN_CLASS_S']);
	Form_Data_onChange("3","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_1",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS_S(Temp_Data);
    setHYBRID_TOKEN_CLASS_S(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS_S));
	Temp_Data["3"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_2"]=value;
	//handleAddHYBRID_TOKEN_CLASS_S(Temp_Data,App_Data['HYBRID_TOKEN_CLASS_S']);
	Form_Data_onChange("3","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_2",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS_S(Temp_Data);
    setHYBRID_TOKEN_CLASS_S(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS_S));
	Temp_Data["4"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_0"]=value;
	//handleAddHYBRID_TOKEN_CLASS_S(Temp_Data,App_Data['HYBRID_TOKEN_CLASS_S']);
	Form_Data_onChange("4","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_0",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS_S(Temp_Data);
    setHYBRID_TOKEN_CLASS_S(Temp_Data);
 }; 
  
  
      
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_1_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS_S));
	Temp_Data["4"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_1"]=value ? true : false; // optionally just use boolean
	//handleAddHYBRID_TOKEN_CLASS_S(Temp_Data,App_Data['HYBRID_TOKEN_CLASS_S']);
	Form_Data_onChange("4","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_1",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS_S(Temp_Data);
    setHYBRID_TOKEN_CLASS_S(Temp_Data);
 }; 
  


    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS_S));
	Temp_Data["5"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_5_0"]=value;
	//handleAddHYBRID_TOKEN_CLASS_S(Temp_Data,App_Data['HYBRID_TOKEN_CLASS_S']);
	Form_Data_onChange("5","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_5_0",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS_S(Temp_Data);
    setHYBRID_TOKEN_CLASS_S(Temp_Data);
 }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS));
	Temp_Data["9"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_0"]=value;
	Form_Data_onChange("9","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_0",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS(Temp_Data);
    setHYBRID_TOKEN_CLASS(Temp_Data);
	//handleAddHYBRID_TOKEN_CLASS(Temp_Data,App_Data['HYBRID_TOKEN_CLASS']);
  }; 
  

    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS_S));
	Temp_Data["9"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_1"]=value;
	//handleAddHYBRID_TOKEN_CLASS_S(Temp_Data,App_Data['HYBRID_TOKEN_CLASS_S']);
	Form_Data_onChange("9","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_1",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS_S(Temp_Data);
    setHYBRID_TOKEN_CLASS_S(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS_S));
	Temp_Data["9"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_2"]=value;
	//handleAddHYBRID_TOKEN_CLASS_S(Temp_Data,App_Data['HYBRID_TOKEN_CLASS_S']);
	Form_Data_onChange("9","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_2",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS_S(Temp_Data);
    setHYBRID_TOKEN_CLASS_S(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS_S));
	Temp_Data["9"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_3"]=value;
	//handleAddHYBRID_TOKEN_CLASS_S(Temp_Data,App_Data['HYBRID_TOKEN_CLASS_S']);
	Form_Data_onChange("9","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_3",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS_S(Temp_Data);
    setHYBRID_TOKEN_CLASS_S(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS_S));
	Temp_Data["9"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_4"]=value;
	//handleAddHYBRID_TOKEN_CLASS_S(Temp_Data,App_Data['HYBRID_TOKEN_CLASS_S']);
	Form_Data_onChange("9","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_4",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS_S(Temp_Data);
    setHYBRID_TOKEN_CLASS_S(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID) => {

};


 
   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
	selectedData = HYBRID_TOKEN_CLASS_S.find(e => e.id == selectedRowId);
    //App_Data.Return_Data=selectedRowId;
    App_Data.Object_Return=selectedRowId;
    //console.log(event.currentTarget.querySelector('td').textContent);
    App_Data.Object_Text=selectedRowId+";"+event.currentTarget.querySelector('td').textContent;
    App_Data.Object_Id=selectedRowId;
	App_Data.Data=selectedData;
	setApp_Data({ ...App_Data})
    window.location.hash = 'Return';
   };
 
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
			  {t('Select Hybrid Token Token Class')}
			  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
			</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item">
					  <a id="navbarNav1" className="nav-link" href="#Return">{t(`Return`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>		 
         {/* Search Fields*/}
         <div className="container-fluid mt-5">
            <h2  id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Advanced Search`)} <span className="toggle-icon">v</span></h2>
            <div  id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`HYBRID Token Class ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_0" type="text" className="form-control" placeholder="HYBRID Token Class ID"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter HYBRID Token Class ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_1" type="text" className="form-control" placeholder="Offering ID"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '80ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Token Class Name`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_2" type="text" className="form-control" placeholder="Token Class Name"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '80ch' }}>
						 {t(`Enter Token Class Name`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '20ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Token Symbol`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_3" type="text" className="form-control" placeholder="Token Symbol"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '20ch' }}>
						 {t(`Enter Token Symbol`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Seniority Level`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_0"   onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_0_Change} className="form-control" name="Seniority Level"  >
						  <option value="Senior">Senior</option>
						  <option value="Preferred">Preferred</option>
						  <option value="Common">Common</option>
						  <option value="Subordinated">Subordinated</option>
						  <option value="Mezzanine">Mezzanine</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Seniority Level
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Token Economic Model`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_1"   onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_1_Change} className="form-control" name="Token Economic Model"  >
						  <option value="Rental Income">Rental Income</option>
						  <option value="Revenue Share">Revenue Share</option>
						  <option value="Sale Profit">Sale Profit</option>
						  <option value="Equity Appreciation">Equity Appreciation</option>
						  <option value="Preferred Return">Preferred Return</option>
						  <option value="Common Equity">Common Equity</option>
						  <option value="Debt Interest">Debt Interest</option>
						  <option value="Hybrid">Hybrid</option>
						  <option value="Pre-Auction Conditional Pool">Pre-Auction Conditional Pool</option>
						  <option value="Post-Auction Tokenization">Post-Auction Tokenization</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Token Economic Model
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Token Ownership Model`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_2"   onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_2_Change} className="form-control" name="Token Ownership Model"  >
						  <option value="No Direct Ownership / Economic Right Only">No Direct Ownership / Economic Right Only</option>
						  <option value="Revenue Participation Right">Revenue Participation Right</option>
						  <option value="Sale Proceeds Participation">Sale Proceeds Participation</option>
						  <option value="Equity Appreciation Participation">Equity Appreciation Participation</option>
						  <option value="Preferred Equity Interest">Preferred Equity Interest</option>
						  <option value="Common Equity Ownership Percentage">Common Equity Ownership Percentage</option>
						  <option value="Debt / Note Holder Claim">Debt / Note Holder Claim</option>
						  <option value="Hybrid Economic Rights">Hybrid Economic Rights</option>
						  <option value="Conditional Auction Pool Right">Conditional Auction Pool Right</option>
						  <option value="Post-Auction Asset Economic Right">Post-Auction Asset Economic Right</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Token Ownership Model
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Preferred Return Percentage`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_0" type="text" className="form-control" placeholder="Preferred Return Percentage"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Preferred Return Percentage`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Debt Interest Rate`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_1" type="text" className="form-control" placeholder="Debt Interest Rate"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Debt Interest Rate`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Profit Split Percentage`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_2" type="text" className="form-control" placeholder="Profit Split Percentage"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_2_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Profit Split Percentage`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Voting Weight`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_0" type="text" className="form-control" placeholder="Voting Weight"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Voting Weight`)}
                     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_1" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Transfer Restricted`)} <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_1" type="checkbox" style={{ marginLeft: '5px' }}  onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_1_Change} 
					  checked={HYBRID_TOKEN_CLASS_S?.["4"]?.["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_1"] === "true" || HYBRID_TOKEN_CLASS_S?.["4"]?.["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_1"] === true} />
					</label>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Class Description`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_5_0" type="text" className="form-control" placeholder="Class Description"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Class Description`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_0"   onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_1" type="text" className="form-control" placeholder="Created By"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_2" type="text" className="form-control" placeholder="Created At"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_3" type="text" className="form-control" placeholder="Updated By"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_4" type="text" className="form-control" placeholder="Updated At"  
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
		 {/* Query Result*/}
         <div className="container-fluid mt-5">
            <h2 style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Query Result`)}</h2>
            <div className="row">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('9')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table9" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`HYBRID Token Class ID`)}</th>
                        <th>{t(`Offering ID`)}</th>
                        <th>{t(`Token Class Name`)}</th>
                        <th>{t(`Token Symbol`)}</th>
                        <th>{t(`Seniority Level`)}</th>
                        <th>{t(`Token Economic Model`)}</th>
                        <th>{t(`Token Ownership Model`)}</th>
                        <th>{t(`Preferred Return Percentage`)}</th>
                        <th>{t(`Debt Interest Rate`)}</th>
                        <th>{t(`Profit Split Percentage`)}</th>
                        <th>{t(`Voting Weight`)}</th>
                        <th>{t(`Transfer Restricted`)}</th>
                        <th>{t(`Class Description`)}</th>
                        <th>{t(`Record Status`)}</th>
                        <th>{t(`Created By`)}</th>
                        <th>{t(`Created At`)}</th>
                        <th>{t(`Updated By`)}</th>
                        <th>{t(`Updated At`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {HYBRID_TOKEN_CLASS_S.map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_0"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_1"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_2"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_3"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_0"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_1"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_2"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_0"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_1"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_2"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_0"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_1"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_5_0"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_0"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_1"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_2"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_3"]} </td>
						<td>{e["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_4"]} </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
  </>;
};

export default HYBRID_Token_Class_S;  